import { JanelaModal } from '../../participantes/ui/JanelaModal';

interface ConfirmacaoDeInicioProps {
    /** `reiniciar` é a fase já jogada: ciclo novo, do zero. */
    acao?: 'iniciar' | 'reiniciar';
    /** Rótulo da fase ("Scan Pixel"). */
    rotulo: string;
    /** Como o modal chama o grupo ("Grupo G03"). */
    grupo: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

/** O popup "Iniciar <fase>?": nomeia grupo e fase antes de abrir a janela (`contexto-para-agentes.md` §10). */
export function ConfirmacaoDeInicio({
    acao = 'iniciar', rotulo, grupo, processando, aoCancelar, aoConfirmar,
}: ConfirmacaoDeInicioProps) {
    const verbo = acao === 'iniciar' ? 'Iniciar' : 'Reiniciar';
    const corpo = acao === 'iniciar'
        ? `${rotulo} será aberto para o ${grupo}. Os tablets do grupo passam a jogar a fase.`
        : `${rotulo} recomeça do zero para o ${grupo}: o progresso da fase é descartado e os tablets voltam a jogá-la; o que já foi pontuado fica.`;
    return (
        <JanelaModal titulo={`${verbo} ${rotulo}?`} aoFechar={aoCancelar} bloqueada={processando}>
            <p>{corpo}</p>
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button type="button" className="botao-confirmar" onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : verbo}
                </button>
            </div>
        </JanelaModal>
    );
}
